/**
 * Mini basket
 */
export default class MiniBasket {
    /** @type {HTMLElement} */
    static instance = null;

    /** @type {HTMLElement} */
    basketElem = null;

    /** @type {HTMLElement} */
    animElem = null;

    /** @type {HTMLElement} */
    quantityElem = null;

    /** @type {Number} */
    quantity = 0;

    constructor(basketElem) {
        this.basketElem = basketElem;

        if (this.basketElem) {
            this.iconElem = this.basketElem.querySelector('.icon');
            this.quantityElem = this.basketElem.querySelector('.quantity');

            const animElem = this.basketElem.querySelector('.icon svg:nth-child(2)');

            if (animElem) {
                this.animElem = animElem.cloneNode(true);
                this.animElem.classList.add('mini-basket-icon');
            }
        }

        if (this.quantityElem) {
            this.quantity = parseInt(this.quantityElem.textContent);
        }

        this.render();
    }

    setQuantity(quantity) {
        this.quantity = parseInt(quantity);

        this.render();
    }

    /** @param {HTMLElement} startElem */
    playAddAnimation(startElem) {
        if (!startElem) {
            return;
        }

        if (!this.animElem) {
            return;
        }

        var rect = startElem.getBoundingClientRect();

        const fromLeft = rect.left;
        const fromTop = rect.top;

        var rect = this.iconElem.getBoundingClientRect();

        const toLeft = rect.left;
        const toTop = rect.top;

        if (this.animElem) {
            this.animElem.style.setProperty('--from-left', fromLeft + 'px');
            this.animElem.style.setProperty('--from-top', fromTop + 'px');
            this.animElem.style.setProperty('--to-left', toLeft + 'px');
            this.animElem.style.setProperty('--to-top', toTop + 'px');

            // Weird hack to restart animation.

            this.animElem.style.animationName = '';

            window.setTimeout(() => {
                this.animElem.style.animationName = 'shoot';
            }, 0);
        }
    }

    render() {
        if (this.basketElem) {
            this.basketElem.classList.toggle('is-toggled', this.quantity > 0);
        }

        if (this.quantityElem) {
            this.quantityElem.textContent = this.quantity;
        }

        if (this.animElem) {
            if (!this.animElem.parentElement) {
                document.body.append(this.animElem);
            }
        }
    }

    static init() {
        const elem = document.querySelector('.mini-basket');

        MiniBasket.instance = new MiniBasket(elem);

        window.MiniBasket = MiniBasket;
    }

    static setQuantity(quantity) {
        if (MiniBasket.instance) {
            MiniBasket.instance.setQuantity(quantity);
        }
    }

    static playAddAnimation(startElem) {
        if (MiniBasket.instance) {
            MiniBasket.instance.playAddAnimation(startElem);
        }
    }
}